window.addEventListener("load", (event) => {
  const elements = document.querySelectorAll('.recommended-products-carousel');

  elements.forEach(elem => {
    if (window.screen.width > 1250) {
      new Flickity( elem, {
        prevNextButtons: false,
        groupCells: true,
        adaptiveHeight: false,
        cellAlign: 'left'
      });
    } else {
      new Flickity( elem, {
        prevNextButtons: false,
        groupCells: true,
        adaptiveHeight: false,
        wrapAround: true
      });
    }
  })

})